import InvStratDiversificationRisk from '@/app/modules/toolkit/inv-strat/components/inv-strat-diversification-risk/inv-strat-diversification-risk.vue';
import InvStratDiversificationConsideration from '@/app/modules/toolkit/inv-strat/components/inv-strat-diversification-consideration/inv-strat-diversification-consideration.vue';
import AssetDiversification from '@/app/constants/store/toolkit/inv-strat/asset-diversification.json';

export default {
  name: 'inv-strat-diversification',
  components: {
    InvStratDiversificationRisk,
    InvStratDiversificationConsideration,
  },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    selection: [],
  }),
  computed: {
    diversificationOptions() {
      return [
        {
          value: 'exp',
          label: `a high exposure to a specific investment within ${this.asset.asset}`,
        },
        {
          value: 'prop',
          label: `a high proportion of the fund allocated to ${this.asset.asset}`,
        },
      ];
    },
    selectionType() {
      if (this.selection.length === 1) {
        return this.selection[0];
      }
      if (this.selection.length > 1) {
        return 'comp';
      }
      return '';
    },
    assetDiversification() {
      if (AssetDiversification[this.asset.asset]) {
        return AssetDiversification[this.asset.asset];
      }
      return [];
    },
    availableRisks() {
      if (this.selectionType) {
        return this.assetDiversification.risks[this.selectionType];
      }
      return [];
    },
    availableConsiderations() {
      if (this.selectionType) {
        const selectedConsiderations = [];
        Object.entries(this.assetDiversification.considerations).forEach((consideration) => {
          const values = Object.values(consideration);
          selectedConsiderations.push({
            [values[0]]: values[1][this.selectionType],
          });
        });
        return [...selectedConsiderations];
      }
      return [];
    },
  },
  watch: {
    selection() {
      this.$emit('assetSelection', this.selectionType);
    },
  },
  methods: {
    handleRiskSelections(event) {
      this.$emit('riskSelections', event);
    },
    handleConsiderationSelections(event) {
      this.$emit('considerationSelections', event);
    },
    clearSelection() {
      this.selection = [];
    },
    loadSelection() {
      this.clearSelection();
      if (this.asset.selection === 'comp') {
        this.selection.push('exp');
        this.selection.push('prop');
      } else if (this.asset.selection !== '') {
        this.selection.push(this.asset.selection);
      }
    },
  },
  activated() {
    this.loadSelection();
  },
};
